if (!customElements.get('get-app')) {
  customElements.define(
    'get-app',
    class GetAppQrPopup extends HTMLElement {
      constructor() {
        super();
        this.getAppBtn = this.querySelector('a[data-track="get_app_click"]');
        this.popupOverlay = this.querySelector('.get-app-popup__overlay');
        this.popupPanel = this.querySelector('.get-app-popup__panel');
        this.closeBtn = this.querySelector('.get-app-popup__close');
        this.onGetAppBtnClick = this.handleGetAppBtnClick.bind(this);
        this.controller = null;
      }

      connectedCallback() {
        const init = () => {
          this.controller = window.createBacksheetController({
            host: this,
            overlay: this.popupOverlay,
            panel: this.popupPanel,
            closeBtn: this.closeBtn,
          });
          this.getAppBtn?.setAttribute('data-device', this.userAgentIsMobile() ? 'mobile' : 'desktop');
          this.getAppBtn?.addEventListener('click', this.onGetAppBtnClick);
          this.controller.bind();
        };

        document.readyState === 'loading'
          ? document.addEventListener('DOMContentLoaded', init, { once: true })
          : init();
      }

      userAgentIsMobile() {
        // 1. Modern approach: use the User-Agent Client Hints API if available
        if (navigator.userAgentData && typeof navigator.userAgentData.mobile !== 'undefined') {
          return navigator.userAgentData.mobile;
        }

        // 2. Fallback to legacy approach
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
      }

      open() {
        this.controller?.open();
      }

      handleGetAppBtnClick(event) {
        if (this.userAgentIsMobile()) return;
        event.preventDefault();
        this.open();
      }

      disconnectedCallback() {
        this.controller?.unbind();
        this.getAppBtn?.removeEventListener('click', this.onGetAppBtnClick);
      }
    },
  );
}
